export default "__VITE_ASSET__1CSiN5g7__"